import { DateTime } from "luxon";

export function dateToFriendlyPostedDate(isoDate: string): string {
  const created = DateTime.fromISO(isoDate).startOf("day");
  const now = DateTime.local().startOf("day");
  const daysDiff = Math.floor(now.diff(created, "days").days);

  if (daysDiff === 0) {
    return "Posted today";
  }

  if (daysDiff === 1) {
    return "Posted yesterday";
  }

  if (daysDiff <= 6) {
    return `Posted ${daysDiff} days ago`;
  }

  if (daysDiff <= 13) {
    return "Posted a week ago";
  }

  if (daysDiff <= 20) {
    return "Posted two weeks ago";
  }

  if (created.month === now.month && created.year === now.year) {
    return "Posted this month";
  }

  return "Posted over a month ago";
}
